<template>
<div class="counter-wrap">
  <div class="counter-row" :class="{ 'ready': ready }">
    <div class="counter-box">

      <div class="counter">
        <canvas class="counter-canvas" width="608" height="668" ref="counter-canvas"></canvas>
        <div class="stars-dom">

<svg width="288px" height="328px" viewBox="0 0 288 328" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <desc>Created with Sketch.</desc>
    <defs>
        <circle id="path-1" cx="274.525" cy="318.225" r="3.325"></circle>
        <filter x="-82.7%" y="-82.7%" width="265.4%" height="265.4%" filterUnits="objectBoundingBox" id="filter-2">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feOffset dx="-1" dy="-1" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
            </feMerge>
        </filter>
        <circle id="path-3" cx="44.625" cy="233.675" r="1.425"></circle>
        <filter x="-193.0%" y="-193.0%" width="486.0%" height="486.0%" filterUnits="objectBoundingBox" id="filter-4">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feOffset dx="-1" dy="-1" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
            </feMerge>
        </filter>
        <circle id="path-5" cx="308.725" cy="270.725" r="1.425"></circle>
        <filter x="-193.0%" y="-193.0%" width="486.0%" height="486.0%" filterUnits="objectBoundingBox" id="filter-6">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feOffset dx="-1" dy="-1" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
            </feMerge>
        </filter>
        <circle id="path-7" cx="56.975" cy="29.425" r="1.425"></circle>
        <filter x="-193.0%" y="-193.0%" width="486.0%" height="486.0%" filterUnits="objectBoundingBox" id="filter-8">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feOffset dx="-1" dy="-1" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
            </feMerge>
        </filter>
        <circle id="path-9" cx="83.575" cy="285.925" r="2.375"></circle>
        <filter x="-115.8%" y="-115.8%" width="331.6%" height="331.6%" filterUnits="objectBoundingBox" id="filter-10">
            <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
            <feOffset dx="-1" dy="-1" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
            </feMerge>
        </filter>
    </defs>
    <g id="Layout-v9" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Artboard" transform="translate(-36.000000, -25.000000)">
            <g id="star-o-7">
                <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use>
            </g>
            <g id="star-o-6">
                <use fill="black" fill-opacity="1" filter="url(#filter-4)" xlink:href="#path-3"></use>
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-3"></use>
            </g>
            <g id="star-o-5">
                <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-5"></use>
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-5"></use>
            </g>
            <g id="star-o-4">
                <use fill="black" fill-opacity="1" filter="url(#filter-8)" xlink:href="#path-7"></use>
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-7"></use>
            </g>
            <image id="star-o-3" transform="translate(309.071611, 50.671611) rotate(45.000000) translate(-309.071611, -50.671611) " x="287.696611" y="39.9841112" width="42.75" height="21.375" xlink:href="data:image/png;base64,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"></image>
            <image id="star-o-2" transform="translate(45.280806, 343.580806) rotate(45.000000) translate(-45.280806, -343.580806) " x="28.6558058" y="335.767056" width="33.25" height="15.6275" xlink:href="data:image/png;base64,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"></image>
            <g id="star-o-1">
                <use fill="black" fill-opacity="1" filter="url(#filter-10)" xlink:href="#path-9"></use>
                <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-9"></use>
            </g>
        </g>
    </g>
</svg>

        </div>
        <div class="counter-dom">

          <div class="raidance-collected">
            <span v-if="SC.U === ENG">Radiance Collected</span>
            <span v-if="SC.U === CHI">籌集閃耀力量</span>
          </div>
          <div class="raidance-counter" d-style="{ 'margin-right': ((number.collected.toFixed(0) + '').length) / 4 * 60 + 120 + 'px' }">
            <span class="raidance-collected-now">{{ number.collectedCount.toFixed(0) }}</span>
            <svg class="raidance-collected-slash" width="11px" height="18px" viewBox="0 0 11 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
                <desc>Created with Sketch.</desc>
                <defs></defs>
                <g id="Layout-v9" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                    <g id="01c-landing-scrolling-opt" transform="translate(-204.000000, -716.000000)" stroke="#979797">
                        <g id="Group-4" transform="translate(90.000000, 671.000000)">
                            <g id="Group-2" transform="translate(0.000000, 11.000000)">
                                <path d="M124,34 L115,52" id="Line-7"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <span class="raidance-collected-full">
             {{ this.full }}
            </span>
          </div>



        </div>

      </div>

    </div>
    <div class="days-to-go-box">
      <div class="days-to-go">
        <span v-if="SC.U === ENG">
          Days To Go
        </span>
        <span v-if="SC.U === CHI">
          尚餘日數
        </span>
      </div>
      <div class="days-to-go-counter">
        {{ daysToGo }} <span v-if="SC.U === CHI" class="days">天</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as Text from '@/components/DOM/Text/Text.js'
import * as Server from '@/components/DOM/Server/Server.js'

import * as TWEEN from '@tweenjs/tween.js'
export default {
  props: {
    now: {},
    full: {},
    ready: {},
    daysToGo: {}
  },
  data () {
    return {
      newNow: 0,
      running: false,
      delay: 500,
      number: {
        collectedCount: 0,
        collected: 0
      },
      ENG: Text.ENG,
      CHI: Text.CHI,
      TT: Text.TT,
      ST: Text.state,
      SC: Text.state,
      T: Text.T
    }
  },
  watch: {
    ready () {
      if (this.ready && !this.running) {
        this.running = true
        this.run()
      }
    }
  },
  mounted () {
    if (this.ready && !this.running) {
      this.running = true
      this.run()
    }
  },
  methods: {
    run () {
      Server.getRadianceCount().then(({ count }) => {
        this.newNow = count
        this.count()
        this.arc()
      })
    },
    arc () {
      var canvas = this.$refs['counter-canvas']
      var ctx = canvas.getContext('2d')

      let www = 304 * 2
      let hhh = 304 * 2

      var drawBase = () => {
        // arc base
        ctx.beginPath()
        ctx.strokeStyle = '#979797'
        ctx.lineWidth = 1
        ctx.arc(www / 2, www / 2, 260, 0, 2 * Math.PI)
        ctx.stroke()

        // line
        ctx.beginPath()
        ctx.lineWidth = 0.5
        ctx.strokeStyle = 'white'
        ctx.moveTo(www / 2, hhh - 140 + 35)
        ctx.lineTo(www / 2, hhh + 20)
        ctx.stroke()
      }

      var PI2 = Math.PI * 2
      var adder = Math.PI * 0.5 + Math.PI * 2
      var tween = new TWEEN.Tween(this.number)
        .to({ collected: this.newNow > 5000 ? 5000 : this.newNow }, 2222)
        .delay(this.delay)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          let per = this.number.collected / this.full
          // per = per < 0.1 ? per * 3 : per
          let r = (1.0 - per) === 0 ? 1 : (1.0 - per)

          ctx.clearRect(0, 0, canvas.width, canvas.height)
          drawBase()

          // arc
          ctx.beginPath()
          ctx.strokeStyle = '#CEBC9E'
          ctx.lineWidth = 10
          ctx.arc(www / 2, hhh / 2, 260, adder, adder + (PI2 * r), true)
          ctx.stroke()
        })

      // var PI2 = Math.PI * 2
      // var adder = Math.PI * 2.0 + Math.PI * 2
      // var tween = new TWEEN.Tween(this.number)
      //   .to({ collected: this.newNow > 5000 ? 5000 : this.newNow }, 2222)
      //   .delay(this.delay)
      //   .easing(TWEEN.Easing.Quadratic.Out)
      //   .onUpdate(() => {
      //     let per = this.number.collected / this.full
      //     let r = (per) === 0 ? 1 : (per)

      //     ctx.clearRect(0, 0, canvas.width, canvas.height)
      //     drawBase()

      //     // arc
      //     ctx.beginPath()
      //     ctx.strokeStyle = '#CEBC9E'
      //     ctx.lineWidth = 10
      //     ctx.arc(www / 2, hhh / 2, 260, adder, adder + (PI2 * r), false)
      //     ctx.stroke()
      //   })

      tween.start()
    },
    count () {
      var tween = new TWEEN.Tween(this.number)
        .to({ collectedCount: this.newNow }, 2222)
        .delay(this.delay)
        .easing(TWEEN.Easing.Quadratic.Out)
      tween.start()
    }
  }
}
</script>

<style scoped>
.counter-row{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.counter-box{
  position: relative;
  width: 304px;
  height: 304px;
}

@media screen and (min-width: 319px) {
  .counter-canvas{
    left: calc(50% - (304px * 0.9) / 2);
    width: calc(304px * 0.9);
    height: calc(334px * 0.9);
  }
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .counter-wrap{
    width: 100%;
    overflow: hidden;
    height: 640px;
  }
  .counter-row{
    transform: scale(1.317);
    height: 640px;
  }
}

.counter-dom{
  position: absolute;
  top: 0px;
  left: calc(50% - 304px / 2);
  width: 304px;
  height: 304px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.counter-canvas{
  position: absolute;
  top: 0px;
  left: calc(50% - 304px / 2);
  width: 304px;
  height: 334px;
}
.stars-dom{
  position: absolute;
  top: 0px;
  left: calc(50% - 304px / 2);
  width: 304px;
  height: 334px;
}

.raidance-counter{
  width: 100%;
  text-align: center;
  transition: width 2s;
  /* margin-right: 120px; */
}
.raidance-collected{
  text-transform: uppercase;
  /* Radiance Collected: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 1.73px;
  text-align: center;
  line-height: 22px;
}

.raidance-collected-now{
  /* 1000: */
  font-family: PlayfairDisplay-Regular, CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 50px;
  color: #CEBC9E;
  letter-spacing: 0;
  text-align: center;
}

.raidance-collected-full{
  /* 1000: */
  font-family: PlayfairDisplay-Regular, CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 27px;
  color: #FFFFFF;
  letter-spacing: 0.34px;
  text-align: center;
}

.raidance-collected-slash{
  display: inline;
}

.days-to-go{
  margin-top: 20px;
  text-transform: uppercase;

  /* Days to go Copy 3: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 0.87px;
  text-align: center;
}

.days-to-go-counter{
  /* 15 copy 4: */
  font-family: PlayfairDisplay-Regular, CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 50px;
  color: #CEBC9E;
  letter-spacing: 0.62px;
  text-align: center;
}
.days{
  font-size: 20px;
}

.counter-row{
  transition: opacity 1s 0.5s;
  opacity: 0;
}
.ready.counter-row{
  opacity: 1;
}

@media screen and (min-width: 767px) {
  .raidance-collected{
    font-size: 16px;
  }
}

/*

.days-to-go,
.days-to-go-counter,
.counter-dom,
.counter-canvas{
  transform: translate3d(0px, 0px, 0.1px);
  transition: opacity 1s 0.5s;
  opacity: 0;
}
.ready .days-to-go,
.ready .days-to-go-counter,
.ready .counter-dom,
.ready .counter-canvas{
  opacity: 1;
}


@keyframes fadeIn {
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}

#star-o-1,
#star-o-2,
#star-o-3,
#star-o-4,
#star-o-5,
#star-o-6,
#star-o-7{
  opacity: 0;
}
.ready #star-o-1{
  animation:fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: calc(0.35s * 1);
}
.ready #star-o-2{
  animation:fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: calc(0.35s * 2);
}
.ready #star-o-3{
  animation:fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: calc(0.35s * 3);
}
.ready #star-o-4{
  animation:fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: calc(0.35s * 4);
}
.ready #star-o-5{
  animation:fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: calc(0.35s * 5);
}
.ready #star-o-6{
  animation:fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: calc(0.35s * 6);
}
.ready #star-o-7{
  animation:fadeIn 1s;
  animation-fill-mode: both;
  animation-delay: calc(0.35s * 7);
}
*/
</style>



// WEBPACK FOOTER //
// src/components/DOM/Counter/Counter.vue